import React from 'react';
import { createRoot } from 'react-dom/client';
import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags';
import { getDocument } from '@atlaskit/browser-apis';
import { App } from './ui/App';

// Brute force new app logos
// eslint-disable-next-line @atlaskit/platform/no-module-level-eval
setBooleanFeatureFlagResolver((flagName) => flagName === 'platform-logo-rebrand');

const rootNode = getDocument()?.getElementById('pillar-root');

if (rootNode) {
	const root = createRoot(rootNode);
	root.render(<App />);
}
